import L from "leaflet";
import AppState from "../core/app.js";

class Basemap {
    constructor() {
        this.layer = null;
        this.meta = null;
    }

    async load() {
        try {
            console.log("Loading Basemap...");

            // ==========================================
            // Read project metadata
            // ==========================================

            const response = await fetch("/api/project");

            if (!response.ok) {
                throw new Error("Cannot load project metadata.");
            }

            this.meta = await response.json();

            console.log("Project:", this.meta);

            // ==========================================
            // Remove previous layer
            // ==========================================

            if (this.layer) {
                AppState.map.removeLayer(this.layer);
            }

            // ==========================================
            // Create Tile Layer
            // ==========================================

            this.layer = L.tileLayer("/api/tile/{z}/{x}/{y}", {
                tileSize: 256,

                minNativeZoom: this.meta.minzoom,

                maxNativeZoom: this.meta.maxzoom,

                maxZoom: this.meta.maxzoom + 4,

                noWrap: true,

                attribution: "Mining Survey",

                crossOrigin: false,
            });

            this.layer.addTo(AppState.map);

            // ==========================================
            // Zoom to project
            // ==========================================

            if (this.meta.boundsArray) {
                const b = this.meta.boundsArray;

                AppState.map.fitBounds([
                    [b[1], b[0]],
                    [b[3], b[2]],
                ]);
            } else if (this.meta.centerObject) {
                const c = this.meta.centerObject;

                AppState.map.setView([c.lat, c.lng], c.zoom);
            }

            console.log("Basemap Loaded");
        } catch (err) {
            console.error(err);

            alert("Cannot load basemap.");
        }
    }

    getLayer() {
        return this.layer;
    }

    getMetadata() {
        return this.meta;
    }

    remove() {
        if (!this.layer) return;

        AppState.map.removeLayer(this.layer);

        this.layer = null;
    }

    reload() {
        return this.load();
    }
}

export default new Basemap();
